import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfodialogComponent } from './infodialog/infodialog.component';
import { MatDialogModule} from '@angular/material';
import {MatButtonModule} from '@angular/material/button';
import { LoadingDialogComponent } from './loading-dialog/loading-dialog.component';
import { LocationPickerDialogComponent } from './location-picker-dialog/location-picker-dialog.component'
import { SharedModule } from '../../../shared/shared.module';
import { PromptDialogComponent } from './prompt-dialog/prompt-dialog.component';
import { FormsModule } from '@angular/forms';
import { SelectUsersDialogComponent } from './select-users-dialog/select-users-dialog.component';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatCardModule } from '@angular/material';
import { DecisionDialogComponent } from '../../../admin-dashboard/optimizer/decision-dialog/decision-dialog.component';
import { EditLocationDialogComponent } from './edit-location-dialog/editLocationDialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    SharedModule,
    FormsModule
  ],
  exports:[
    LocationPickerDialogComponent,
  ],
  declarations: [
    InfodialogComponent,
    LoadingDialogComponent,
    LocationPickerDialogComponent,
    PromptDialogComponent,
    SelectUsersDialogComponent,
    DecisionDialogComponent,
    EditLocationDialogComponent
  ],
  entryComponents:[
    InfodialogComponent,
    LoadingDialogComponent,
    LocationPickerDialogComponent,
    PromptDialogComponent,
    SelectUsersDialogComponent,
    DecisionDialogComponent,
    EditLocationDialogComponent
  ]
})
export class DialogModule { }
